import { connect } from 'react-redux';
import * as offersSelectors from 'redux-modules/offers/selectors.js';
import * as offersActions from 'redux-modules/offers/actions.js';
import Offers from './Offers';

function mapStateToProps(state) {
  return {
    offers: offersSelectors.selectOffers(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(offersActions.loadOffers());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
